<template>
<va-card>
  <div>
    
    <p class="display-3 text-center">Bienvenido</p>
  </div>
</va-card>
</template>

<script>
export default {
  
}
</script>

<style scoped>

</style>